package com.merkost.handpass.admin.components

import androidx.compose.runtime.Composable
import com.merkost.handpass.sharedweb.components.WebModal

@Composable
fun AdminModal(onDismiss: () -> Unit, content: @Composable () -> Unit) {
    WebModal(onDismiss = onDismiss, content = content)
}
